var FormFeedbackDelayNote = (function ($) {

    var FormFeedbackDelayNote = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];

        // Address block
        that.select_toggle_address = '.js-toggle-address'
        that.$address_field = that.$wrapper.find('.js-address-field')

        // DYNAMIC VARS
        that.locales = options['locales'] || {};

        // INIT
        that.init(options);
    };

    var Self = FormFeedbackDelayNote;
    Self.className = 'FormFeedbackDelayNote';
    var Parent = FormAbstract;

    var def = FormAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;

        options.onDoneSubmitCallback = function (response) {
            var unique_id = response?.data?.unique_id;

            that.$wrapper.find('.js-form').hide();
            that.$wrapper.find('.js-success-result').show();
            that.$wrapper.find('.js-unique-id').text(unique_id);
            $.sa.scrollToNode(that.$wrapper, 200, null);
        }

        options.onAlertSubmitCallback = function (error) {
            var msg = error && error.message ? error.message : that.locales.error_message;
            $.uiModal({
                header_icons: '<div class="align-center"><i class="fab fa-sa-fill-mood-suprised2"></i><i class="fab fa-sa-fill-circle-x"></i></div>',
                header_title: '<div class="align-center">' + that.locales.error_title + '</div>',
                content: '<div class="align-center">' + msg + '</div>',
                button_align_center: true,
                button_confirm_text: that.locales.confirm_text,
            });
        }

        Parent.prototype.init.call(that, options);

        that.initToggles();

        that.initInputMask();
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            form: '.js-form',
            previous_action: '', 
        };

        that.method = 'POST';

        that.url = def(options.url, '');
        that.has_success_screen = false;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.initInputMask = function () {
        var that = this;

        UIInputMask.prototype.initPnrMask(that.$wrapper);
        UIInputMask.prototype.initPhoneMask(that.$wrapper);
        UIInputMask.prototype.initEmailValidate(that.$wrapper);
    }

    Self.prototype.initToggles = function () {
        var that = this;

        that.initAddressToggle();
    }

    Self.prototype.initAddressToggle = function () {
        var that = this;

        $.sa.$document.on('change', that.select_toggle_address, function (e) {
            var $toggle_select = $(e.target);

            if ($toggle_select.hasClass(that.select_toggle_address.substring(1))) {
                var selected_type = $toggle_select.val();

                that.$address_field.hide();
                
                if (selected_type === 'yes') {
                    that.$address_field.show();
                }
            }

        });
    }

    return Self;
})(jQuery);